import React from 'react';
import {
  Wrapper,
  GridRow,
  Cell,
  CellNumber,
  CellIcon,
  HeaderNumber,
  HeaderCell,
  TextTruncate,
  ColorIcon,
} from './AllocationTable.styles';
import { IAllocation } from '../types';
import { getFormattedCurrency } from 'utils/format';
import { ICurrencyFormat } from 'utils/types';
import { getTotalPercentage } from '../utils';
import { OTHERS_LABEL, CHART_COLOR_PALLETTE } from '../PieChart/utils';
import orderBy from 'lodash/orderBy';
import OthersColorIcon from './OthersColorIcon';
import { ApIcon, colors } from '@alixpartners/ui-components';

interface IProps {
  onAppRemove(appId: number): void;
  spend: number;
  data: IAllocation[];
  format: ICurrencyFormat;
  title: string;
  othersLabel?: string;
}

const MAX_PERCENTAGE = 100;

export const AllocationTable: React.FC<IProps> = ({
  onAppRemove,
  data,
  spend,
  format,
  title,
  othersLabel,
}) => {
  const totalPercentage = getTotalPercentage(data);
  const orderedAllocations = orderBy(
    data,
    ['percentage', 'name'],
    ['desc', 'asc']
  );

  return (
    <Wrapper>
      <GridRow>
        <CellIcon></CellIcon>
        <HeaderCell>{title} name</HeaderCell>
        <HeaderNumber>Allocation</HeaderNumber>
        <HeaderNumber>Spend value</HeaderNumber>
        <CellIcon></CellIcon>
      </GridRow>
      {orderedAllocations.map(({ id, name, percentage }, index) => {
        const colorIndex = index % CHART_COLOR_PALLETTE.length;

        return (
          <GridRow key={id}>
            <CellIcon>
              <ColorIcon color={CHART_COLOR_PALLETTE[colorIndex]} />
            </CellIcon>
            <Cell title={name}>
              <TextTruncate>{name}</TextTruncate>
            </Cell>
            <CellNumber isInvalid={totalPercentage > MAX_PERCENTAGE}>
              {percentage}%
            </CellNumber>
            <CellNumber>
              {getFormattedCurrency({
                value: (spend * percentage) / MAX_PERCENTAGE,
                currencyFormat: format,
                isUnitSign: true,
                isCurrencySign: true,
                isIdealDenomination: true,
              })}
            </CellNumber>
            <CellIcon onClick={() => onAppRemove(id)}>
              <ApIcon
                iconName="baseline_close"
                iconSize={16}
                iconColor={colors.grey4}
              />
            </CellIcon>
          </GridRow>
        );
      })}
      {totalPercentage < MAX_PERCENTAGE && (
        <GridRow isInactive>
          <CellIcon>
            <OthersColorIcon />
          </CellIcon>
          <Cell>
            <TextTruncate>{othersLabel || OTHERS_LABEL}</TextTruncate>
          </Cell>
          <CellNumber>{MAX_PERCENTAGE - totalPercentage}%</CellNumber>
          <CellNumber>
            {getFormattedCurrency({
              value:
                (spend * (MAX_PERCENTAGE - totalPercentage)) / MAX_PERCENTAGE,
              currencyFormat: format,
              isUnitSign: true,
              isCurrencySign: true,
              isIdealDenomination: true,
            })}
          </CellNumber>
        </GridRow>
      )}
    </Wrapper>
  );
};
